import DataQuery from 'data/DataQuery';
import { Customer_EconomicalTariff } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react';
import { useSelector } from 'react-redux';
import { EconomicalTariffResultDTO } from 'features/economicalTariff/dtos/EconomicalTariffResultDTO';
import EconomicalTariffItem from '../components/EconomicalTariffItem';
import DataGridRow from 'features/shared/components/dataGrid/DataGridRow';
import EconomicalTariffItemHeader from '../components/EconomicalTariffItemHeader';
import EconomicalTariffUsage from '../components/EconomicalTariffUsage';
import EconomicalTariffUsageHeader from '../components/EconomicalTariffUsageHeader';
import { useTranslation } from 'react-i18next';

type Props = {}

const EconomicalTariffSection = (props: Props) => {
  // translations
  const t = useTranslation("economicalTariff\\economicalTariff").t;

  // store
  const customer = useSelector<IAppState, CustomerState>( (store) => store.customer).customer;

  // fetch data
  const query: DataQuery = {
    url: Customer_EconomicalTariff,
    routeParams: getRouteParams("customerId", customer.customerId!)
  };
  const { data: economicalTariff, loadStatus } = useQuery<EconomicalTariffResultDTO>(query, {});

  // sub-renders
  const renderTariffs = () => { 
    return economicalTariff.tariffs?.map((item, index) =>
      <DataGridRow key={index}>
        <EconomicalTariffItem 
          tariff={item} 
        />
      </DataGridRow>
    );
  }

  const renderUsages = () => { 
    return economicalTariff.usages?.map((item, index) =>
      <DataGridRow key={index}>
        <EconomicalTariffUsage 
          usage={item} 
        />
      </DataGridRow>
    );
  }

  // render
  return (
    <NoContentWrapper
      data={economicalTariff}
      loadStatus={loadStatus}
      noContentAsAlert
    >
      <h4 className="text-muted">{t("economicalTariffSection.tariffsTitle")}</h4>
      <EconomicalTariffItemHeader />
      {renderTariffs()}

      <h4 className="text-muted mt-4">{t("economicalTariffSection.usagesTitle")}</h4>
      <EconomicalTariffUsageHeader />
      {renderUsages()}
    </NoContentWrapper>
  )
}

export default EconomicalTariffSection;